/**
 * UnreadToggle — global "Unread only" filter switch.
 *
 * When ON, the page scopes all leads and counts to leads the current user
 * hasn't read yet. The state is owned by the parent page and persisted to
 * localStorage("global_unread_only") so it carries between the Dashboard and
 * the Lead List. Off by default.
 *
 * Controlled component: pass `value` (boolean) and `onChange(nextValue)`.
 */
const UnreadToggle = ({ value, onChange }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={value}
      data-spotlight="unread-only-toggle"
      data-attr="unread-only-toggle"
      onClick={() => onChange(!value)}
      title={
        value
          ? "Showing unread leads only. Click to show all leads."
          : "Showing read and unread leads. Click to show unread only."
      }
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${
        value
          ? "bg-teal-600 text-white border-teal-600"
          : "bg-white text-gray-700 border-border hover:border-teal-300 hover:text-teal-700"
      }`}
    >
      <span className="flex items-center gap-1.5">
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        Unread only
      </span>
      {/* Switch track */}
      <span
        className={`relative inline-block w-8 h-4 rounded-full transition-colors ${
          value ? "bg-white/40" : "bg-gray-300"
        }`}
      >
        <span
          className={`absolute top-0.5 left-0.5 w-3 h-3 rounded-full bg-white shadow transition-transform ${
            value ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </span>
    </button>
  );
};

export default UnreadToggle;
